import React from 'react'

import { useSelectedTab } from '../../tabs/hooks'

import styles from './MobileSidebar.module.css'

const MobileSidebar = ({ basePath, children }) => {
  const selectedTab = useSelectedTab()

  if (selectedTab === basePath || selectedTab === basePath + '/') return null

  return <div className={styles.sideBar}>{children}</div>
}

export default MobileSidebar
